import { UsedBanksState } from './types';
import { RootState } from 'store/root-reducer';
import { createSelector } from '@reduxjs/toolkit';

const selectUsedBanksReducer = (state: RootState): UsedBanksState => state.usedBanks;

export const selectUsedBanksIsEmpty = createSelector(
  [selectUsedBanksReducer],
  (usedBanks) => usedBanks.usedBanksIsEmpty
);

export const selectUsedBanksLoading = createSelector(
  [selectUsedBanksReducer],
  (usedBanks) => usedBanks.usedBanksLoading
);

export const selectUsedBanks = createSelector([selectUsedBanksReducer], (usedBanks) => usedBanks.usedBanks);
